// Description: Component for adding threat intelligence data with necessary fields and file uploads.
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import axios from 'axios';
import AceEditor from "react-ace";

import screenshotSvg from '../assets/screenshot.svg';
import htmlSvg from '../assets/html.svg';
import screenshotSelectedSvg from '../assets/screenshot_selected.svg';
import htmlSelectedSvg from '../assets/html_selected.svg';
import { Form, Row, Col } from "react-bootstrap";
import UploadFile from './common/UploadFile/UploadFile';
import SelectBox from './common/selectbox/selectBox';
import ConfirmPopup from "./common/popover/confirmPopup";
import LoaderWrapper from "./common/LoaderWrapper/LoaderWrapper";

import { formatDetectionDatetime } from '../utilities/datetime';
import { isGlobalView } from '../utilities/config';
import { loadEventById, addThreatIntel, unSetStatusCode } from '../store/entities/events';
import { getIndustryLookupData, getCountryLookupData, getStateLookupData, getCityLookupData } from '../store/entities/lookup';
import { validateURL} from '../utilities/vaildations';
import { setCurrentCustomer } from '../store/entities/customers'; 
import { loadHTML, loadScreenshotResized } from '../store/entities/superFeedEvents';
import { eventTypes } from '../utilities/eventTypes'

import './AddThreatIntel.scss';

import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/theme-solarized_light"

const screenshotPlaceholder = `${process.env.REACT_APP_EXTERNAL_PAGES_BASE_URL}/placeholders/screenshot.jpeg`;
const defaultOptObj = {value: '', name: 'Select...', id: 'DEF_VAL' }

const DEFAULT_THREAT_EVENT_RECORD = {
  eventId: '',
  url: '',
  brands: [],
  detectionTime: '',
  country: defaultOptObj,
  state: defaultOptObj,
  city: defaultOptObj,
  industry: defaultOptObj,
  imageData: {
    image: '',
    fileName: '',
  },
  HtmlData: {
    html: '',
    fileName: '',
  },
  showConfirmationPopup: false,
}

class AddThreatIntel extends Component {
    constructor(props) {
    super(props);
    this.state = {
      incidentEventRecord: DEFAULT_THREAT_EVENT_RECORD,
      pageContent: '',
      selectedTab: 1,
      previewTab: 1,
      addImage: true, // Set to true by default
      addHtml: true,  // Set to true by default
      previewImageData: {
        image: "",
        fileName: 'screenshot.jpeg',
      },
      previewHtmlData: {
        html: '',
        fileName: 'pageContent.html',
      },
      showConfirmationPopup:false,
      showWarningPopup:false,
      errors:[]

    };
    this.originalIncidentEventRecord = {};
    this.screenshotFileUploadRef = React.createRef();
    this.htmlFileUploadRef = React.createRef();
  }

  formatIcidentEventRecord = (event) => {
    if (event === null) {
      console.warn("No event data provided, returning default record.");
      return null;
    }
    return {
      eventId: event.eventId || event.id || '', //Events from superfeed have eventId for verification instead of Id
      url: event.url || '',
      brands: event.brands || event.detectedBrands || [],
      detectionTime: event.detectionTime || event.detectedOn || '',
      country:  event.country || defaultOptObj,
      state:   event.state || defaultOptObj,
      city:  event.city || defaultOptObj,
      industry:  event.industry || defaultOptObj,
      imageData: {
        image: event.resizedScreenshotURL || screenshotPlaceholder, 
        fileName: 'screenshot.jpeg',
      },
      HtmlData: {
        html: event.pageContentURL || '',
        fileName: 'pageContent.html',
      },
    };
  }

  async componentDidMount() {
    const { match, selectedEvent, industries, countries, states, cities, customerList, eventScreenshots, eventHtml } = this.props;

    industries.length == 0 && this.props.getIndustryLookupData();
    countries.length == 0 && this.props.getCountryLookupData();

    try {
      // If selectedEvent is already available in props
      if (selectedEvent && selectedEvent.id) {
        const formattedRecord = this.formatIcidentEventRecord(selectedEvent);
        
        // Set previewImageData from eventScreenshots if available
        const eventId = selectedEvent.eventId || selectedEvent.id;
        const screenshotUrl = eventScreenshots?.[eventId] || screenshotPlaceholder;
        
        // Set previewHtmlData from eventHtml if available
        const htmlContent = eventHtml?.[eventId] || "";
        
        this.setState({
          incidentEventRecord: formattedRecord,
          previewImageData: {
            image: screenshotUrl,
            fileName: 'screenshot.jpeg',
          },
          previewHtmlData: {
            html: htmlContent,
            fileName: 'pageContent.html',
          },
          // Ensure checkboxes are checked if we have content
          addImage: true,
          addHtml: true
        });
        this.originalIncidentEventRecord = formattedRecord;
        this.loadPageContentScreenshot();
      }
      // If we need to fetch the event
      else if (match && match.params.param3) {
        await this.props.loadEventById(this.props.match.params.param3, 
        this.props.match.params.param2 || this.props.match.params.param1,
        )
        // After getEvent completes, check if selectedEvent is available
        if (this.props.selectedEvent) {
          const formattedRecord = this.formatIcidentEventRecord(this.props.selectedEvent);
          
          // Set previewImageData from eventScreenshots if available
          const eventId = this.props.selectedEvent.eventId || this.props.selectedEvent.id;
          const screenshotUrl = eventScreenshots?.[eventId] || screenshotPlaceholder;
          
          // Set previewHtmlData from eventHtml if available
          const htmlContent = eventHtml?.[eventId] || "";
          
          this.setState({
            incidentEventRecord: formattedRecord,
            previewImageData: {
              image: screenshotUrl,
              fileName: 'screenshot.jpeg',
            },
            previewHtmlData: {
              html: htmlContent,
              fileName: 'pageContent.html',
            },
            // Ensure checkboxes are checked if we have content
            addImage: true,
            addHtml: true
          });
          this.originalIncidentEventRecord = formattedRecord;
        }
      }
    } catch (error) {
      console.error("Error initializing component:", error);
    }
  }

  getDataSelectBox = (field) => {
    let dataArr = [defaultOptObj];
    field.forEach((item) => 
      dataArr.push({
        name: item.value,
        value: item.value,
        id: item.code,
      }));
    return dataArr;
  }
      

  handleDropdownChange = (selectedOption) => {
    const { type } = selectedOption;

    if(type === 'country') {
      // reset State when Country is changed
      this.handleDropdownChange({ ...defaultOptObj, type: 'state'});
      // get the states for the selected country
      this.props.getStateLookupData(selectedOption.id);
    }
    if(type === 'state') {
      //reset City when State is changed
      this.handleDropdownChange({ ...defaultOptObj, type: 'city' });
      // get the cities for the selected state and country only if the state is not default
      if(selectedOption.id != "DEF_VAL")
        this.props.getCityLookupData(selectedOption.id, this.state.incidentEventRecord.country.id);
    }

    this.setState((prevState) => ({
      incidentEventRecord: {
        ...prevState.incidentEventRecord,
        [selectedOption.type]: selectedOption ? {
          id: selectedOption.id || '',
          value: selectedOption.value || '',
          name: selectedOption.name || ''
        } : defaultOptObj,
      }
    }));
  };

  loadPageContentScreenshot = async () => {
    const { selectedEvent: event, selectedCustomer: currentCustomer } = this.props;
    let pageContentURL = '';
    try {
      if (event && !this.state.pageContent) {
        const customers = this.props.customerList || [];
        let container = '';
        let customerId = '';
        let eventId = '';
        let extensionInstallId = '';
        let HTML_TYPE = 'h';
        let IMG_TYPE = 'i';

        if(event && event.eventId !== undefined) {
          // Logic to get initialize event parameters for super feed events
          container = customers.find(c => c.id === event.customerId)?.blobContainer || '';
          customerId = event.customerId;
          eventId = event.eventId;
          extensionInstallId = event.extensionInstallId;
        }
        else {
          // Logic to get initialize event parameters for Customer-threat feed events
          pageContentURL = (event.status === "AI Suspicious" || event.status === "Google Form Password" || event.status === "Unknown") ? `${event.markedScreenshotURL?.slice(0, -12)}.html` : event.pageContentURL; //constructing the html url from the markeScreenshotUrl
          // Converting double slash (//) to single slash (/) in the URL if exists. This done as URLs in PROD env have double slashes in the Blob Container Name.
          let urlParts = pageContentURL.replace("//", "/").split("/").filter((ele)=>ele!="");
          container = urlParts[2];
          customerId = urlParts[3];
          extensionInstallId = urlParts[4];
          eventId = event.id;
        }
        console.log({container, customerId, extensionInstallId, eventId})
        this.props.loadHTML(container, [customerId, extensionInstallId], eventId, HTML_TYPE, eventId);
        this.props.loadScreenshotResized(container, [customerId, extensionInstallId], `${eventId}${event.type === eventTypes.reported_phish? "" : "_resized"}`, IMG_TYPE, eventId);
        // We don't need to update previewImageData here since componentDidUpdate will handle 
        // this when eventScreenshots prop changes
      }
    }
    catch(err){
      console.error('Error in loading page content', err);
      this.setState({ pageContent: 'Error in loading HTML content' });
    }
  }

  
  async componentDidUpdate(prevProps) {
    const { selectedEvent: event, selectedCustomer, customerList, eventScreenshots, eventHtml } = this.props;

    if(selectedCustomer && selectedCustomer.id !== prevProps.selectedCustomer.id) {
      // Reset the state when the selected customer changes
      this.handleOnReset();
      // Reset the page content
      this.setState({ pageContent: '' });
      return;
    } 

    // Only process if event changed and is valid
    if (event !== prevProps.selectedEvent && event) {
      // Update the incidentEventRecord when a new event is selected
      const formattedRecord = this.formatIcidentEventRecord(event);
      
      // Set previewImageData from eventScreenshots if available
      const eventId = event.eventId || event.id;
      const screenshotUrl = eventScreenshots?.[eventId] || screenshotPlaceholder;
      
      // Set previewHtmlData from eventHtml if available
      const htmlContent = eventHtml?.[eventId] || "";
      
      this.setState({
        incidentEventRecord: formattedRecord,
        previewImageData: {
          image: screenshotUrl,
          fileName: 'screenshot.jpeg',
        },
        previewHtmlData: {
          html: htmlContent,
          fileName: 'pageContent.html',
        },
        // Ensure checkboxes are checked if we have content
        addImage: true,
        addHtml: true
      });
      this.originalIncidentEventRecord = formattedRecord;
      this.loadPageContentScreenshot();
    }
    
    // Update previewImageData when eventScreenshots changes and contains the current event
    if (prevProps.eventScreenshots !== eventScreenshots && event) {
      const eventId = event.eventId || event.id;
      if (eventScreenshots && eventScreenshots[eventId]) {
        this.setState({
          previewImageData: {
            image: eventScreenshots[eventId],
            fileName: 'screenshot.jpeg',
          }
        });
      }
    }
    
    // Update previewHtmlData when eventHtml changes and contains the current event
    if (prevProps.eventHtml !== eventHtml && event) {
      const eventId = event.eventId || event.id;
      if (eventHtml && eventHtml[eventId]) {
        this.setState({
          previewHtmlData: {
            html: eventHtml[eventId],
            fileName: 'pageContent.html',
          }
        });
      }
    }
  }

  handleUrlChange = (event) => {
    const { value } = event.target;
    this.setState((prevState) => ({
      incidentEventRecord: {
        ...prevState.incidentEventRecord,
        url: value,
      },
    }));
  }

  handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const { selectedEvent, eventScreenshots, eventHtml } = this.props;

    // Reset the corresponding preview data when checkbox is unchecked
    if (!checked) {
      if (name === 'addImage') {
        // Reset file input when unchecking to allow re-upload of same file later
        if (this.screenshotFileUploadRef.current) {
          this.screenshotFileUploadRef.current.reset();
        }
        this.setState({
          addImage: false,
          previewImageData: {
            image: "",
            fileName: 'screenshot.jpeg',
          },
        });
      } else if (name === 'addHtml') {
        // Reset file input when unchecking to allow re-upload of same file later
        if (this.htmlFileUploadRef.current) {
          this.htmlFileUploadRef.current.reset();
        }
        this.setState({
          addHtml: false,
          previewHtmlData: {
            html: "",
            fileName: 'pageContent.html',
          },
        });
      }
    } else {
      // When checkbox is checked again, restore the default data from props
      if (name === 'addImage' && selectedEvent) {
        // Get the event ID
        const eventId = selectedEvent.eventId || selectedEvent.id;
        // Get the screenshot URL from eventScreenshots or use the placeholder
        const screenshotUrl = eventScreenshots?.[eventId] || screenshotPlaceholder;
        
        // Reset file input to allow re-upload
        if (this.screenshotFileUploadRef.current) {
          this.screenshotFileUploadRef.current.reset();
        }
        
        this.setState({
          addImage: true,
          previewImageData: {
            image: screenshotUrl,
            fileName: 'screenshot.jpeg',
          },
        });
      } else if (name === 'addHtml' && selectedEvent) {
        // Get the event ID
        const eventId = selectedEvent.eventId || selectedEvent.id;
        // Get the HTML content from eventHtml or use empty string
        const htmlContent = eventHtml?.[eventId] || "";
        
        // Reset file input to allow re-upload
        if (this.htmlFileUploadRef.current) {
          this.htmlFileUploadRef.current.reset();
        }
        
        this.setState({
          addHtml: true,
          previewHtmlData: {
            html: htmlContent,
            fileName: 'pageContent.html',
          },
        });
      } else {
        // Default case if no event is selected
        this.setState({ [name]: checked });
      }
    }
  };

  handleHtmlFileChange = (fileInfo) => {
    if(fileInfo) {
      this.setState({
        ...this.state,
        previewHtmlData: {
          ...this.state.previewHtmlData,
          fileName: fileInfo.name,
          html: fileInfo.content,
        }
      }, () => {
        // Reset the input to allow re-uploading the same file later
        // This is called after state update to ensure the file is processed first
        if (this.htmlFileUploadRef.current) {
          this.htmlFileUploadRef.current.reset();
        }
      });
    }
  }

  handleImageFileChange = (fileInfo) => {
    if(fileInfo) {
      this.setState({
        ...this.state,
        previewImageData: {
          ...this.state.previewImageData,
          fileName: fileInfo.name,
          image: fileInfo.base64,
        }
      }, () => {
        // Reset the input to allow re-uploading the same file later
        // This is called after state update to ensure the file is processed first
        if (this.screenshotFileUploadRef.current) {
          this.screenshotFileUploadRef.current.reset();
        }
      });
    }
  }

  handleOnReset = (e) => {
    if(e)
      e.preventDefault();
    
    const { selectedEvent, eventScreenshots, eventHtml } = this.props;
    
    // Get event ID for fetching the default data
    const eventId = selectedEvent?.eventId || selectedEvent?.id;
    
    // Get default values from props
    const defaultScreenshotUrl = eventScreenshots?.[eventId] || screenshotPlaceholder;
    const defaultHtmlContent = eventHtml?.[eventId] || "";
    
    this.setState({
      incidentEventRecord: JSON.parse(JSON.stringify(this.originalIncidentEventRecord)),
      previewImageData: {
        image: defaultScreenshotUrl,
        fileName: 'screenshot.jpeg',
      },
      previewHtmlData: {
        html: defaultHtmlContent,
        fileName: 'pageContent.html',
      },
      addImage: true,  // Keep as true when resetting
      addHtml: true,   // Keep as true when resetting
    }, () => {
      // Reset the file inputs
      if (this.screenshotFileUploadRef.current) {
        this.screenshotFileUploadRef.current.reset();
      }
      
      if (this.htmlFileUploadRef.current) {
        this.htmlFileUploadRef.current.reset();
      }
    });
  }

  handleOnCancel = () => {
    this.handleOnReset();
    this.redirectToThreatFeed();
  }

  addEventThreatIntel = () => {
      const payload = this.createThreatIntelPayload(); 
      this.props.addThreatIntel(payload, this.state.incidentEventRecord.eventId, this.props.match.params.param2 || this.props.match.params.param1);      
      this.setState({showConfirmationPopup: false})
  }

  validatePayload = (payload) => {
    let errors = [];

    if (!payload.threatURL || payload.threatURL.trim() === '') {
      errors.push('URL is required.');
    }
    if (!validateURL(payload.threatURL)) {
      errors.push('Invalid URL format.'); 
    }
    if (!payload.threatDetectedOn || payload.threatDetectedOn.trim() === '') {
      errors.push('Detection Time is required.');
    }
    if(this.state.addImage && (!payload.screenshot || !payload.screenshot || payload.screenshot.trim() === '')) {
      errors.push('Screenshot is required when "Add Image" is checked.');
    }
    if(this.state.addHtml && (!payload.html || !payload.html || payload.html.trim() === '')) {
      errors.push('HTML file is required when "Add HTML" is checked.');
    }

    if(errors.length>0){
      this.setState({
        showWarningPopup: true,
        errors: errors
      })
      return false;
    }
    return true;
  }

  handleWarningPopupClose = () => {
    this.setState({
      showWarningPopup: false,
      errors: []
    })
  }

  handleOnClose = () => {
    this.setState({
      showConfirmationPopup: false
    })
  }

  handleOnCloseConfirmationPopup = () => {
    let {statusCode} = this.props;
    if(statusCode && statusCode === 200) {
      this.redirectToThreatFeed();
    }
    this.setState({
      showConfirmationPopup: false
    })
    this.props.unSetStatusCode();
  }

  createThreatIntelPayload = () => {
    const { incidentEventRecord, previewImageData, previewHtmlData, addHtml, addImage } = this.state;
    return {
      threatURL: incidentEventRecord.url,
      threatDetectedOn: incidentEventRecord.detectionTime,
      industry: this.isDefaultOption(incidentEventRecord.industry.id) ? '' : incidentEventRecord.industry.id,
      country: this.isDefaultOption(incidentEventRecord.country.id) ? '' : incidentEventRecord.country.id,
      state: this.isDefaultOption(incidentEventRecord.state.id) ? '' : incidentEventRecord.state.id,
      city: this.isDefaultOption(incidentEventRecord.city.id) ? '' : incidentEventRecord.city.id,
      screenshot: addImage ? previewImageData.image : "",
      html: addHtml ? previewHtmlData.html : "", 
      isVerify : true,
      submittedOn : new Date().toISOString(),
    };
  }

  isDefaultOption = (id) => {
    return id === 'DEF_VAL' || id === '' || id === null;
  }
  
 handleOnSubmit = (e) =>{
    e.preventDefault();
    const payload = this.createThreatIntelPayload();
      if(this.validatePayload(payload)) {
          this.setState({
            showConfirmationPopup: true
          })
      }
  }

  redirectToThreatFeed = () => {
    const { selectedCustomer, history, location } = this.props;
    // If a 'from' route is provided in location.state, redirect there
    if (location && location.state && location.state.from) {
      history.push(location.state.from);
    } else {
      history.push(
        `${isGlobalView(selectedCustomer.organizationName)
          ? '/tenants'
          : '/customers'}/${selectedCustomer.id}/incidents`
      );
    }
  }

  render() {
    const { incidentEventRecord: event, previewImageData, previewHtmlData, previewTab,  addImage, addHtml } = this.state;
    let txtURL = event.url || '';
    let { industries, countries, states, cities } = this.props;
    let { eventScreenshots, eventHtml: html, selectedEvent } = this.props;
    return (
      <div className={`mt-4`}>
        <>
                         {
            this.props.eventLoading || this.props.threatIntelLoading?
            <LoaderWrapper loading={this.props.eventLoading || this.props.threatIntelLoading} waitForData={false} isFlex={true} styles={{top: '100px'}}></LoaderWrapper>
          : <>
              <div className="threat-intel-form container-md">
                <div className='titleStyle mb-4'>
                    Add to Threat Intelligence
                </div>                
                <Form>
                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3 ">
                        <Form.Label className='textStyle'>URL:</Form.Label>
                        <Form.Control type="text" value={txtURL} onChange={this.handleUrlChange}/>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className='textStyle'>Detection Time:</Form.Label>
                        <Form.Control type="text" value={formatDetectionDatetime(event.detectionTime)} disabled/>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className='textStyle'>Brands:</Form.Label>
                        <Form.Control type="text" value={event.brands && event.brands.length ? event.brands : 'NA'} disabled/>
                      </Form.Group>

                      <Form.Group as={Row} className="align-items-center mb-2">
                        <Col xs="auto">
                          <Form.Check
                            // className='textStyle'
                            type="checkbox"
                            label={<span className='textStyle' style={{fontSize:"14px"}}>Add Image:</span>}
                            name="addImage"
                            checked={addImage}
                            onChange={this.handleCheckboxChange}
                          />
                        </Col>
                        <Col>
                        <div className={`fileUploadInput ${addImage? 'activeBtn' : 'disabledBtn'}`}>
                          <UploadFile
                              ref={this.screenshotFileUploadRef}
                              disabled={!addImage}
                              inputId={'screenshotFile'}
                              onDone={this.handleImageFileChange} 
                              submitText={'Upload Screenshot'}
                              accept={".jpg,.jpeg"}
                          />
                        </div>
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="align-items-center mb-4">
                        <Col xs="auto">
                          <Form.Check
                            type="checkbox"
                            label={<span className='textStyle' style={{fontSize:"14px"}}>Add HTML:</span>}
                            name="addHtml"
                            checked={addHtml}
                            onChange={this.handleCheckboxChange}
                          />
                        </Col>
                        <Col>
                        <div className={`fileUploadInput ${addHtml? 'activeBtn' : 'disabledBtn'}`}>
                          <UploadFile
                              ref={this.htmlFileUploadRef}
                              disabled={!addHtml}
                              inputId={'htmlFile'}
                              onDone={this.handleHtmlFileChange} 
                              submitText={'Upload HTML'}
                              accept={".html,.htm,text/html"}
                          />
                        </div>
                        </Col>
                      </Form.Group>

                      <Row className="mb-3">
                        <Col>
                          <Form.Label className='textStyle'>Industry:</Form.Label>
                            <SelectBox
                              role="PixmAdmin"
                              width="300px"
                              optionBoxWidth="300px"
                              selectedOption={event.industry}
                              options={this.getDataSelectBox(industries)}
                              onSelect={(opt) => this.handleDropdownChange(opt)}
                              type="industry"
                              showSearch={true}
                              bordered={true}
                            />
                        </Col>
                      </Row>
                    </Col>

                    <Col md={4}>
                      <div className="preview-container">
                        <div className="tabs pointer">
                          <div
                              className="tab rightLine"
                              onClick={() => this.setState({ previewTab: 1 })}
                            >
                              <img
                                src={
                                  previewTab === 1
                                    ? screenshotSelectedSvg
                                    : screenshotSvg
                                }
                                width="25px"
                              />
                              <span style={{ color: previewTab === 1 && '#2d5fa7' }}>
                                Screenshot
                              </span>
                            </div>
                            <div
                              className="tab"
                              onClick={() => this.setState({ previewTab: 2 })}
                            >
                              <img
                                src={previewTab === 2 ? htmlSelectedSvg : htmlSvg}
                                width="25px"
                              />
                              <span style={{ color: previewTab === 2 && '#2d5fa7' }}>
                                HTML
                              </span>
                            </div>
                        </div>
                        <div className="preview-box">
                          {previewTab === 1 && eventScreenshots && (
                          <div className="imageContainer">
                            <img
                              src={eventScreenshots?.[selectedEvent?.eventId ?? selectedEvent?.id] || screenshotPlaceholder}
                              className={'dataImg'}
                              style={{          
                                maxWidth: '100%', 
                                height: '300px', 
                                objectFit: 'contain',
                                display: 'block' 
                              }}
                            />
                          </div>
                            )}
                            {previewTab === 2 && (
                              <div className="codeblockView">
                                <AceEditor
                                  placeholder="This is a placeholder html template"
                                  height='300px'
                                  width='100%'
                                  mode="html"
                                  theme="solarized_light"
                                  name="html_content"
                                  fontSize={10}
                                  lineHeight={10}
                                  showPrintMargin={false}  
                                  showGutter={true}
                                  highlightActiveLine={true}
                                  value={html?.[selectedEvent.eventId ?? selectedEvent.id] ?? "This is a placeholder html template"}
                                  readOnly={true}
                                  wrapEnabled={true}
                                  setOptions={{
                                    enableBasicAutocompletion: false,
                                    enableLiveAutocompletion: false,
                                    enableSnippets: false,
                                    showLineNumbers: true,
                                    tabSize: 2,
                                    wrap: true
                                  }}/>
                              </div>
                            )}
                        </div>
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="preview-container">
                        <div className="tabs pointer">
                          <div
                              className="tab rightLine"
                              onClick={() => this.setState({ previewTab: 1 })}
                            >
                              <img
                                src={
                                  previewTab === 1
                                    ? screenshotSelectedSvg
                                    : screenshotSvg
                                }
                                width="25px"
                              />
                              <span style={{ color: previewTab === 1 && '#2d5fa7' }}>
                               New Screenshot
                              </span>
                            </div>
                            <div
                              className="tab"
                              onClick={() => this.setState({ previewTab: 2 })}
                            >
                              <img
                                src={previewTab === 2 ? htmlSelectedSvg : htmlSvg}
                                width="25px"
                              />
                              <span style={{ color: previewTab === 2 && '#2d5fa7' }}>
                                New HTML
                              </span>
                            </div>
                        </div>
                        <div className="preview-box">
                          {previewTab === 1 && (
                          <div className="imageContainer">
                            <img
                              src={this.state.previewImageData.image || screenshotPlaceholder}
                              className='dataImg'
                              style={{          
                                maxWidth: '100%', 
                                height: '300px', 
                                objectFit: 'contain',
                                display: 'block' 
                              }}
                            />
                          </div>
                            )}
                            {previewTab === 2 && (
                              <div className="codeblockView">
                                <AceEditor
                                  placeholder="This is a placeholder html template"
                                  height='300px'
                                  width='100%'
                                  mode="html"
                                  theme="solarized_light"
                                  name="html_content"
                                  fontSize={10}
                                  lineHeight={10}
                                  showPrintMargin={false}  
                                  showGutter={true}
                                  highlightActiveLine={true}
                                  value={this.state.previewHtmlData.html? this.state.previewHtmlData.html : "This is a placeholder html template"}
                                  readOnly={true}
                                  wrapEnabled={true}
                                  setOptions={{
                                    enableBasicAutocompletion: false,
                                    enableLiveAutocompletion: false,
                                    enableSnippets: false,
                                    showLineNumbers: true,
                                    tabSize: 2,
                                    wrap: true
                                  }}/>
                              </div>
                            )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col>
                      <Form.Label className='textStyle'>Country:</Form.Label>
                        <SelectBox
                            role="PixmAdmin"
                            width="300px"
                            optionBoxWidth="300px"
                            selectedOption={event.country}
                            options={this.getDataSelectBox(countries)}
                            onSelect={(opt) => this.handleDropdownChange(opt)}
                            type="country"
                            showSearch={true}
                            bordered={true}
                          />
                    </Col>
                    <Col>
                      <Form.Label className='textStyle'>State:</Form.Label>
                        <SelectBox
                          role="PixmAdmin"
                          width="300px"
                          optionBoxWidth="300px"
                          selectedOption={event.state}
                          options={this.getDataSelectBox(states.filter((state, index)=>state.str_flex_field_1 == this.state.incidentEventRecord.country.id))}
                          onSelect={this.handleDropdownChange}
                          type="state"
                          showSearch={true}
                          bordered={true}
                        />
                    </Col>
                    <Col>
                      <Form.Label className='textStyle'>City:</Form.Label>
                        <SelectBox
                          role="PixmAdmin"
                          width="300px"
                          optionBoxWidth="300px"
                          selectedOption={event.city}
                          options={this.getDataSelectBox(cities.filter((city, index)=>city.str_flex_field_1 == this.state.incidentEventRecord.country.id))} //&& city.str_flex_field_2 == this.state.incidentEventRecord.state.id))}
                          onSelect={this.handleDropdownChange}
                          type="city"
                          showSearch={true}
                          bordered={true}
                        />
                    </Col>
                    </Row>

                  <div className="form-buttons mt-4 d-flex justify-content-between">
                    <div>
                      <button className='cancelButton focus-none' onClick={this.handleOnReset}>
                        Reset
                      </button>
                    </div>
                    <div>
                      <button className="cancelButton me-2 focus-none" onClick={this.handleOnCancel}>
                        Cancel
                      </button>
                      <button className='submitButton' onClick={this.handleOnSubmit}>
                        Submit
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </>}
              {this.state.showWarningPopup && (
                <ConfirmPopup
                details={{
                  icon: '',
                  type: 'warning',
                  title: 'Invalid Inputs!',
                  description: `The Following inputs are invalid: \n ${this.state.errors.map((error,index)=>`${index+1}. ${error} \n`)}`,
                  buttons: 'O',
                }}
                onCloseClick={this.handleWarningPopupClose}
                />
              )}

              {this.state.showConfirmationPopup && (
                <ConfirmPopup
                details={{
                  icon: '',
                  type: 'info',
                  title: 'Are You Sure?',
                  description: "Do you want to add this event to Threat Intelligence?",
                  buttons: 'Y,C',
                }}
                onCancelClick={this.handleOnClose} 
                onYesClick= {this.addEventThreatIntel}
                />
              )}
      
              {
                this.props.statusCode && (
                  <ConfirmPopup
                  details={{
                    icon: '',
                    type: this.props.statusCode ==  200? 'success':'error',
                    title: this.props.statusCode ==  200? `Event Submitted To Threat Intelligence`:`Event Could not be added to Threat Intelligence`,
                    description: this.props.errorMsg || "Event has been submitted for Verification. It will appear in Threat Intelligence Feed soon.",
                    buttons: 'O',
                  }}
                  onCloseClick={this.handleOnCloseConfirmationPopup} 
                />
                )}
        </>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  eventLoading: state.entities.events.loading,
  lookupLoading: state.entities.lookup.loading,
  threatIntelLoading: state.entities.events.threatIntel.loading,
  selectedEvent: state.entities.events.selected,
  selectedCustomer: state.entities.customers.selected,
  tokenRoles: state.entities.user.roles,
  industries: state.entities.lookup.industries,
  countries: state.entities.lookup.countries,
  states: state.entities.lookup.states,
  cities: state.entities.lookup.cities,
  statusCode: state.entities.events.threatIntel.status,
  errorMsg: state.entities.events.threatIntel.userMsg,
  customerList: state.entities.customers.list,
  eventHtml: state.entities.superFeedEvents.html,
  eventScreenshots: state.entities.superFeedEvents.screenshots,
})

const mapDispatchToProps = (dispatch) => ({
  loadEventById: (eventId, customerId) =>
    dispatch(loadEventById(eventId, customerId)),
  getIndustryLookupData: () => dispatch(getIndustryLookupData()),
  getCountryLookupData: () => dispatch(getCountryLookupData()),
  getStateLookupData: (countryCode) => dispatch(getStateLookupData(countryCode)),
  getCityLookupData: (stateCode, countryCode) => dispatch(getCityLookupData(stateCode, countryCode)),
  addThreatIntel: (payload, eventId, customerId) => dispatch(addThreatIntel(payload, eventId, customerId)),
  unSetStatusCode: () => dispatch(unSetStatusCode()),
  setCurrentCustomer: (customer) => dispatch(setCurrentCustomer(customer)),
  loadHTML: (container, filepath, blobName, type, eventId) => dispatch(loadHTML(container, filepath, blobName, type, eventId)),
  loadScreenshotResized: (container, filepath, blobName, type, eventId) => dispatch(loadScreenshotResized(container, filepath, blobName, type, eventId)),
  
})

export default connect(mapStateToProps, mapDispatchToProps)(AddThreatIntel)
